export type TimePeriod = (typeof TIMEPERIODS)[number];

export const TIMEPERIODS = [
  {
    iD: 1,
    name: 'Last hour',
  },
  {
    iD: 2,
    name: 'Last 24h',
  },
  {
    iD: 3,
    name: 'Last 7 Days',
  },
  {
    iD: 4,
    name: 'Last Month',
  },
  {
    iD: 5,
    name: 'Last Year',
  },
  {
    iD: 6,
    name: 'This Month',
  },
  {
    iD: 7,
    name: 'Billing Day',
  },
  {
    iD: 8,
    name: 'Previous Month',
  },
  {
    iD: 9,
    name: 'Custom',
  },
] as const;
